import type { ReactNode } from 'react';
import msMark from '../../theme/mighty-spatial-mark.png';

/** The white brand card on the dark backdrop: logo, title, spaced uppercase subtitle (sign-in and intro splash). */
export function BrandCard({
  logoUrl,
  title,
  subtitle,
  children,
}: {
  logoUrl: string | null;
  title: string;
  subtitle: string | null;
  children?: ReactNode;
}) {
  return (
    <div className="mm-brandcard">
      {logoUrl && <img className="mm-brandcard-logo" src={logoUrl} alt="" />}
      <h1 className="mm-brandcard-title">{title}</h1>
      {subtitle && <div className="mm-brandcard-sub">{subtitle}</div>}
      {children}
    </div>
  );
}

export function PoweredBy() {
  return (
    <div className="mm-powered">
      Designed by
      <img src={msMark} alt="" />
      <b>Mighty Spatial</b>
    </div>
  );
}
